import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { PERMISSION_TYPE } from '../enums/PermissionType';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private authService: AuthService) {}

  public hasPermission(permission: string): boolean {
    if (this.authService.getPermissions().find((p) => p === permission)) return true;
    if (!permission.includes('.')) return false;
    const permissionSegments = permission.split('.');
    const permissionWithoutLastSegment = permissionSegments.slice(0, permissionSegments.length - 1).join('.');
    return this.hasPermission(permissionWithoutLastSegment);
  }

  public isSubCon(): boolean {
    return this.hasPermission(PERMISSION_TYPE.MODULE.SHIPPER_CONTRACTOR.toString());
  }
}
